import React from 'react';
import { JcCommonProps, JcSize } from '../utils/JcUtils';
import { JcLoadingIndicator } from './JcLoadingIndicator';
import { JcPlaceholder } from './JcPlaceholder';

export interface JcLoadingPlaceholderProps extends JcCommonProps {
    size?: JcSize;
    label?: React.ReactNode;
    delayMs?: number;
    // Unique ID to help with debugging
    id: string;
}

export const JcLoadingPlaceholder: React.FunctionComponent<JcLoadingPlaceholderProps> = (props: JcLoadingPlaceholderProps) => {
    const { label, size, delayMs, ...commonProps } = props;

    return <JcPlaceholder {...commonProps}>
        <JcLoadingIndicator size={size} delayMs={delayMs} />
        {label}
    </JcPlaceholder>
}
